<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Solicitud de precios</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-title>
                        <v-container flex grid-list-sm>
                            <v-layout wrap align-center justify-center>
                                <v-flex class="text-xs-right">
                                    <v-btn color="green" dark @click.stop="crudOpen('add')">
                                        Agregar
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :pagination.sync="pag"
                            :total-items="totalItems"
                            :loading="loading"
                            rows-per-page-text="Filas por pagina"
                            no-data-text="No hay datos"
                            disable-initial-sort
                            item-key="id"
                            class="tabla-compacta-col"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.item.id }}</td>
                            <td class="text-xs-center">{{ (props.item.tipo)? props.item.tipo.desig : 'NO ASIGNADO' }}</td>
                            <td class="text-xs-center">
                                <div v-if="props.item.item">FRIOLATINA: {{ props.item.item.micro_id_1 }}</div>
                                <div v-if="props.item.item">BERVILL: {{ props.item.item.micro_id_2 }}</div>
                                <div v-if="props.item.item">ACEROLATINA: {{ props.item.item.micro_id_3 }}</div>
                            </td>
                            <td class="text-xs-center" v-if="props.item.item">{{ props.item.item.descripcion }}</td>
                            <td class="text-xs-center">{{ props.item.valor | moneda }}</td>
                            <td class="text-xs-center">{{ props.item.user.name }}</td>
                            <td class="text-xs-center">
                                <v-icon v-if="props.item.creado === 1" color="green">check</v-icon>
                                <v-icon v-else color="red">close</v-icon>
                            </td>
                            <td class="text-xs-center">
                                <v-btn v-if="props.item.creado !== 1" flat icon @click.native="crudDestroy(props.item.id)" color="red" :loading="loadingDel === props.item.id">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                                <v-btn v-if="tienePermiso && props.item.creado !== 1" flat icon @click.native="crudConfirm(props.item.id)" color="green" :loading="loadingConfirm === props.item.id">
                                    <v-icon>check</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="crudDialog" persistent max-width="600px">
            <v-card>
                <v-toolbar dark>
                    <v-toolbar-title>Agregar registro</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="crudDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-autocomplete clearable label="Tipo de producto" v-model="d.item_tipos_id" :items="item_tipos" item-value="id" item-text="desig"></v-autocomplete>
                    <item-select v-model="item" :id.sync="d.item_id" :tipo="d.item_tipos_id"></item-select>
                    <v-text-field label="Precio" v-model="d.valor"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red" @click="crudDialog = false">Cancelar</v-btn>
                    <v-btn dark color="green" @click="crudStore()" :loading="crudloading">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import moneda from '../../filters/moneda';
    import itemSelect from '../../components/ItemSelect';
    import mixinPrecio from '../../mixins/precios';
    import mixinItems from '../../mixins/items';
    import {mapActions, mapGetter} from 'vuex';

    function initialData() {
        return {
            item_tipos_id: '',
            item_id: '',
            valor: 0,
        }
    }

    export default {
        name: "solicitud",
        filters: {moneda},
        mixins: [mixinPrecio, mixinItems],
        components: {itemSelect},
        data() {
            return {
                tienePermiso: false,
                search: '',
                totalItems: 0,
                loading: false,
                d: initialData(),
                headers: [
                    {text: 'ID', value: 'id', align: 'center'},
                    {text: 'Tipo', value: 'item_tipos_id', align: 'center'},
                    {text: 'Código', value: 'item_id', align: 'center'},
                    {text: 'Descripción', value: 'descripcion', align: 'center'},
                    {text: 'Precio', value: 'valor', align: 'center'},
                    {text: 'Solicitante', value: 'user_id', align: 'center'},
                    {text: 'Creado', value: 'creado', align: 'center'},
                ],
                items: [],
                pag: {
                    sortBy: 'id',
                    descending: true
                },
                filtro: {
                    tipo: ''
                },
                rows: [10, 20, 30, {text: 'Todo', value: -1}],
                crudDialog: false,
                crudloading: false,
                loadingDel: -1,
                loadingConfirm: -1,
                oper: 'add',
                item_tipos: [],
                item: {}
            }
        },
        watch: {
            pag: {
                handler() {
                    this.getData();
                },
                deep: true,
                immediate: false
            }
        },
        mounted() {
            this.precioSolicitudPermiso(r => {
                this.tienePermiso = r;
            }, err => console.error(err));
            this.getData();
            this.itemTipos(r => {
                this.item_tipos = r;
            }, err => console.error(err));
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            ...mapActions('progreso', ['progresoShow', 'progresoHide', 'progresoPorcent']),
            crudOpen(oper) {
                this.oper = oper;
                this.crudDialog = true;
            },
            crudStore() {
                this.crudloading = true;
                this.precioSolicitudStore(this.d, r => {
                    this.msjShow(r);
                    this.crudloading = false;
                    this.getData();
                    this.crudDialog = false;
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al guardar registro'});
                    this.crudloading = false;
                })
            },
            crudDestroy(id) {
                this.loadingDel = id;
                this.precioSolicitudDestroy(id, r => {
                    this.msjShow(r);
                    this.loadingDel = -1;
                    this.getData();
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al eliminar registro'});
                    this.loadingDel = -1;
                })
            },
            crudConfirm(id) {
                this.loadingConfirm = id;
                this.precioSolicitudConfirma(id, r => {
                    this.msjShow(r);
                    this.loadingConfirm = -1;
                    this.getData();
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al eliminar registro'});
                    this.loadingConfirm = -1;
                })
            },
            getData() {
                this.loading = true;
                this.pag.search = this.search;
                this.pag.filtro = this.filtro;
                this.precioSolicitudIndex(this.pag, r => {
                    this.items = r.data;
                    this.totalItems = r.total;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
            update(item) {
                this.itemUpdate(item.id, item, r => {
                    this.msjShow(r);
                    this.getData()
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al guardar'});
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/precios/solicitud.vue